<template>
  <div class="status-change-procedure-batch-roll-class">
    <div class="tips">
      <div class="label">转班设置：</div>
      <div class="setup">
        <el-checkbox v-model="setupOverride">启用转班记录覆盖</el-checkbox>
        <div class="tip-msg">启用后，同一学生，表格录入的转班记录将覆盖学生在平台已提交的转班申请记录</div>
      </div>
    </div>
    <DataImportModule import-url="/workspace/manager/status/change/procedure/batch/rollClass"
                      inline
                      v-bind="$attrs"
                      v-on="$listeners"></DataImportModule>
  </div>
</template>

<script>
import DataImportModule from '../../../../../../../../elements/DataImportModule'
export default {
  name: 'StatusChangeProcedureBatchRollClass',
  components: {
    DataImportModule
  },
  data () {
    return {
      setupOverride: false
    }
  }
}
</script>

<style lang="scss">
  .status-change-procedure-batch-roll-class {
    & > .tips {
      margin-bottom: 10px;
      & > .label {
        color: #606266;
        font-size: 12px;
        font-weight: bold;
        margin-top: 12px;
        margin-bottom: 12px;
      }
      & > .setup {
        .el-checkbox {
          .el-checkbox__label {
            font-size: 12px;
          }
        }
        .tip-msg {
          margin-top: 4px;
          color: #909399;
          font-size: 12px;
        }
      }
    }
  }
</style>
